// extracted by mini-css-extract-plugin
export default {"CloseButton--desktop":"CloseButton-styles__CloseButton--desktop__HNHe3","CloseButton--mobile":"CloseButton-styles__CloseButton--mobile__CUDki"};